import * as angular from 'angular';
import * as moment from 'moment';

import * as wtByteToSize from './byteToSize.filter';
import * as wtCapitalize from './capitalize.filter';
import * as wtCron from './cron.filter';
import * as wtDate from './date.filter';
import * as wtNumber from './number.filter';
import * as wtFrequency from './frequencyFormatter.filter';
import * as wtUnescape from './unescape';

import { serviceModule } from '../services/services.module';

export default angular.module('wt-filters', [serviceModule])
    .constant('moment', moment)
    .filter(wtCapitalize.filterId, wtCapitalize.factory)
    .filter(wtCron.filterId, wtCron.factory)
    .filter(wtDate.filterId, wtDate.factory)
    .filter(wtNumber.filterId, wtNumber.factory)
    .filter(wtByteToSize.filterId, wtByteToSize.factory)
    .filter(wtFrequency.filterId, wtFrequency.factory)
    .filter(wtUnescape.filterId, wtUnescape.factory)
    .name;